var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineUsers16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1839 13.3333V12.0741C15.1839 10.6831 14.0563 9.55556 12.6654 9.55556H12.3506M10.1468 7.03704C11.5378 7.03704 12.6654 5.90946 12.6654 4.51852C12.6654 3.12758 11.5378 2 10.1468 2M11.4061 13.3333V12.0741C11.4061 10.6831 10.2785 9.55556 8.88759 9.55556H3.85055C2.45961 9.55556 1.33203 10.6831 1.33203 12.0741V13.3333M8.88759 4.51852C8.88759 5.90946 7.76001 7.03704 6.36907 7.03704C4.97813 7.03704 3.85055 5.90946 3.85055 4.51852C3.85055 3.12758 4.97813 2 6.36907 2C7.76001 2 8.88759 3.12758 8.88759 4.51852Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineUsers16);
export default __webpack_public_path__ + "static/media/outline-users-16.890c2a4b.svg";
export { ForwardRef as ReactComponent };